/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useEffect, useState } from "react";
import { IApprovalFlowStep } from "../../../../interfaces/approvalFlowSteps";
import { useParams } from "react-router-dom";
import { debounce } from "lodash";
import { listApprovalFlowSteps } from "@/services";
import { updateValue } from "@/utils/updateValue";
import { useEntityQueryParams } from "@/hooks/useEntityQueryParams";
import { useEntitySearch } from "@/hooks/useEntitySearch";

const defaultApprovalFlow: IApprovalFlowStep = {
    id: 0,
    idApprovalFlow: 0,
    name: ""
};

export const useApprovalFlowSteps = ({
  disabledGetAll,
  filter: filterInitial,
}: {
  filter?: Record<string, any>;
  disabledShowId?: boolean;
  disabledGetAll?: boolean;
}) => {
  const { idApprovalFlow: id } = useParams();
  const [approvalFlowSteps, setApprovalFlowSteps] = useState<IApprovalFlowStep[]>([]);
  const [approvalFlowStep, setApprovalFlowStep] = useState<IApprovalFlowStep>(defaultApprovalFlow);
  const { filter, handleFilter, page, setPage, limit, setLimit } =
    useEntityQueryParams({ filter: filterInitial, defaultLimit: 25 });
  const [totalItems, setTotalItems] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleApprovalFlow = (key: string, value: any) => {
    setApprovalFlowStep((curr) => {
      const newData = updateValue(curr, key, value);
      return { ...curr, ...newData };
    });
  };

  const getAll = useCallback(
    debounce(
      ({
        page = 1,
        limit,
        filter,
      }: {
        page?: number;
        limit?: number;
        filter?: any;
      }) => {
        setLoading(true);
        listApprovalFlowSteps({
          includes: ["createdBy", "updatedBy"],
          page,
          filter: filter,
          limit,
        })
          .then(
            ({ approvalFlowSteps, limit, currentPage, totalItems }) => {
              setApprovalFlowSteps(approvalFlowSteps);
              
              setLimit(Number(limit));
              setTotalItems(Number(totalItems));
            }
          )
          .finally(() => setLoading(false));
      },
      150
    ),
    []
  );


  const search = useEntitySearch({ list: listApprovalFlowSteps, key: "approvalFlowSteps", filter });

  useEffect(() => {
    if (!disabledGetAll) getAll({ page, limit, filter });
  }, [page, limit, filter]);

  return {
    approvalFlowSteps,
    approvalFlowStep,
    loading,
    setPage,
    setLimit,
    page,
    limit,
    handleApprovalFlow,
    id,
    setTotalItems,
    totalItems,
    handleFilter,
    search
  };
};
